export default "__VITE_ASSET__B3b1Tz6W__"